'use client';

import { Suspense } from 'react';

import AnalyticsLogger from './logger/analytics-logger.component';

import { LocationSelectionModal } from '@/app/(main)/(pages)/(home)/_components/location/_components/location-selection-modal.component';
import { LoadNProgressRouter } from '@/app/(main)/(pages)/(autoload)/load-nprogress-router/load-nprogress-router.component';
import LoadUserComponent from '@/app/(main)/(pages)/(autoload)/load-user.component';
import { SearchModal } from '@/app/(main)/_components/search-modal/search-modal.component';
import ScrollToTop from '@/components/ui/scroll-to-top.component';
import { Toaster } from '@/components/ui/toaster.component';
import { FeatureFlagProvider } from '@/feature-flags/providers/FeatureFlagProvider';
import { useAuthInit } from '@/hooks/use-auth-init.hook';

function AuthInitializer() {
  useAuthInit();
  return null;
}

export function ClientProviders({ children }: React.PropsWithChildren) {
  return (
    <FeatureFlagProvider>
      <Suspense fallback={null}>
        <AuthInitializer />
      </Suspense>
      <AnalyticsLogger />
      <LoadUserComponent />
      <Suspense>
        <LoadNProgressRouter />
        <ScrollToTop />
        <Toaster />
        <SearchModal />
        <LocationSelectionModal />
      </Suspense>
      {children}
    </FeatureFlagProvider>
  );
}
